"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var Observable_1 = require("rxjs/Observable");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var me_serialization_service_1 = require("./me-serialization.service");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var me_kb_http_service_1 = require("./me-kb-http.service");
var me_data_service_1 = require("../service/me-data.service");
var indicator_entity_model_1 = require("../model/indicator-entity.model");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var HttpMEService = /** @class */ (function () {
    function HttpMEService(_dataService, _meKbService, _languageService, _classifierService, _currentLanguageProvider, _applicationPropertiesService) {
        this._dataService = _dataService;
        this._meKbService = _meKbService;
        this._languageService = _languageService;
        this._classifierService = _classifierService;
        this._currentLanguageProvider = _currentLanguageProvider;
        this._applicationPropertiesService = _applicationPropertiesService;
        this.URL_ENTITY_ADD = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "/entity/", ""], ["", "/entity/", ""])), 'serviceUri', 'systemName');
        this.URL_ENTITY_DELETE = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", "/entity/", "/", ""], ["", "/entity/", "/", ""])), 'serviceUri', 'systemName', 'entityId');
        this.URL_ENTITY_LOAD_MANY = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", "/entity/", "/flat"], ["", "/entity/", "/flat"])), 'serviceUri', 'systemName');
        this.URL_ENTITY_LOAD_ONE = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", "/entity/", "/", ""], ["", "/entity/", "/", ""])), 'serviceUri', 'systemName', 'entityId');
        this.URL_ENTITY_UPDATE = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", "/entity/", "/", ""], ["", "/entity/", "/", ""])), 'serviceUri', 'systemName', 'entityId');
        this.URL_LOAD_ENTITY_BY_INSTANCE_ID = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", "/entity/", "/instance/", ""], ["", "/entity/", "/instance/", ""])), 'serviceUri', 'systemName', 'entityInstanceId');
        this.URL_GET_WORKFLOW_ACTIONS = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", "/workflow/", "/", "/action"], ["", "/workflow/", "/", "/action"])), 'serviceUri', 'systemName', 'entityId');
        this.URL_DO_WORKFLOW_ACTION = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", "/workflow/", "/", "/action/", ""], ["", "/workflow/", "/", "/action/", ""])), 'serviceUri', 'systemName', 'entityId', 'actionId');
        this.ME_SERVICE_URI_KEY = "me-de-service-url";
        this._meSerializationService = null;
        this._meSerializationService = new me_serialization_service_1.MESerializationService(_meKbService, _languageService, _classifierService, this);
    }
    HttpMEService.prototype.add = function (systemName, entity, indicatorEntityAdditionalDataModel) {
        var _this = this;
        var queryParams;
        var entitySystemName = systemName === 'IndicatorTemplate' ? 'Indicator' : systemName;
        return Observable_1.Observable.from(this._applicationPropertiesService.getProperty(this.ME_SERVICE_URI_KEY)).flatMap(function (serviceUri) {
            var url = _this.URL_ENTITY_ADD.replaceTemplate({
                serviceUri: serviceUri,
                systemName: systemName,
            });
            return _this._currentLanguageProvider.getCurrentLanguage().first().flatMap(function (language) {
                queryParams = [];
                queryParams.push(new idm_de_core_frontend_1.SearchParam('languageId', language.getId()));
                return _this._meSerializationService.serializeEntity(entitySystemName, entity);
            }).flatMap(function (entity) {
                var data = {
                    entity: entity,
                    additionalData: indicatorEntityAdditionalDataModel
                };
                return _this._dataService.add(url, data, queryParams);
            }).flatMap(function (data) {
                return _this._meSerializationService.deserializeMainEntityWithMeta(entitySystemName, data);
            });
        });
    };
    HttpMEService.prototype.validate = function (systemName, entity, indicatorEntityAdditionalDataModel) {
        var _this = this;
        var queryParams;
        var entitySystemName = systemName === 'IndicatorTemplate' ? 'Indicator' : systemName;
        return Observable_1.Observable.from(this._applicationPropertiesService.getProperty(this.ME_SERVICE_URI_KEY)).flatMap(function (serviceUri) {
            var url = _this.URL_ENTITY_ADD.replaceTemplate({
                serviceUri: serviceUri,
                systemName: 'indicator/validate',
            });
            return _this._currentLanguageProvider.getCurrentLanguage().first().flatMap(function (language) {
                queryParams = [];
                queryParams.push(new idm_de_core_frontend_1.SearchParam('languageId', language.getId()));
                return _this._meSerializationService.serializeEntity(entitySystemName, entity);
            }).flatMap(function (entity) {
                var data = {
                    entity: entity,
                    additionalData: indicatorEntityAdditionalDataModel
                };
                return _this._dataService.add(url, data, queryParams);
            }).flatMap(function (data) {
                return _this._meSerializationService.deserializeMainEntityWithMeta(entitySystemName, data);
            });
        });
    };
    HttpMEService.prototype.createBlankEntity = function (systemName) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(systemName);
        return this._meKbService.getMetaFields(systemName)
            .map(function (metaFields) {
            var entityBuilder = new idm_de_core_frontend_1.EntityBuilder();
            return entityBuilder.createEntity(indicator_entity_model_1.IndicatorEntity, metaFields);
        });
    };
    HttpMEService.prototype.delete = function (systemName, entity) {
        return this.deleteById(systemName, entity.getId());
    };
    HttpMEService.prototype.deleteById = function (systemName, entityId) {
        var _this = this;
        return Observable_1.Observable.from(this._applicationPropertiesService.getProperty(this.ME_SERVICE_URI_KEY))
            .flatMap(function (serviceUri) {
            var url = _this.URL_ENTITY_DELETE.replaceTemplate({
                entityId: entityId.toString(),
                serviceUri: serviceUri,
                systemName: systemName,
            });
            return _this._currentLanguageProvider.getCurrentLanguage().first()
                .flatMap(function (language) {
                var queryParams = [];
                queryParams.push(new idm_de_core_frontend_1.SearchParam('languageId', language.getId()));
                return _this._dataService.delete(url, queryParams);
            });
        });
    };
    HttpMEService.prototype.loadEntityByInstanceId = function (systemName, entityInstanceId, withTransientFields, fieldSystemNames) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(systemName);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(entityInstanceId);
        return Observable_1.Observable.from(this._applicationPropertiesService.getProperty(this.ME_SERVICE_URI_KEY)).flatMap(function (serviceUri) {
            var url = _this.URL_LOAD_ENTITY_BY_INSTANCE_ID.replaceTemplate({
                entityInstanceId: entityInstanceId.toString(),
                serviceUri: serviceUri,
                systemName: systemName,
            });
            var entityDataObservable = _this._currentLanguageProvider.getCurrentLanguage().first().flatMap(function (language) {
                var queryParams = [];
                queryParams.push(new idm_de_core_frontend_1.SearchParam('languageId', language.getId()));
                queryParams.push(new idm_de_core_frontend_1.SearchParam('withTransientFields', withTransientFields !== undefined && withTransientFields));
                if (fieldSystemNames) {
                    queryParams.push(new idm_de_core_frontend_1.SearchParam('metaFields', fieldSystemNames));
                }
                return _this._dataService.load(url, queryParams);
            });
            return _this._meSerializationService.deserializeMainEntity(systemName === 'IndicatorTemplate' ? 'Indicator' : systemName, entityDataObservable, fieldSystemNames);
        });
    };
    HttpMEService.prototype.update = function (systemName, entity, indicatorEntityAdditionalDataModel) {
        var _this = this;
        var queryParams;
        var entitySystemName = systemName === 'IndicatorTemplate' ? 'Indicator' : systemName;
        return Observable_1.Observable.from(this._applicationPropertiesService.getProperty(this.ME_SERVICE_URI_KEY)).flatMap(function (serviceUri) {
            var url = _this.URL_ENTITY_UPDATE.replaceTemplate({
                entityId: entity.getId().toString(),
                serviceUri: serviceUri,
                systemName: systemName,
            });
            return _this._currentLanguageProvider.getCurrentLanguage().first().flatMap(function (language) {
                queryParams = [];
                queryParams.push(new idm_de_core_frontend_1.SearchParam('languageId', language.getId()));
                return _this._meSerializationService.serializeEntity(entitySystemName, entity);
            }).flatMap(function (entity) {
                var data = {
                    entity: entity,
                    additionalData: indicatorEntityAdditionalDataModel
                };
                return _this._dataService.update(url, data, queryParams);
            }).flatMap(function (data) {
                return _this._meSerializationService.deserializeMainEntityWithMeta(entitySystemName, data);
            });
        });
    };
    HttpMEService.prototype.getWorkflowActions = function (systemName, entity) {
        var _this = this;
        var queryParams;
        return Observable_1.Observable.from(this._applicationPropertiesService.getProperty(this.ME_SERVICE_URI_KEY)).flatMap(function (serviceUri) {
            var url = _this.URL_GET_WORKFLOW_ACTIONS.replaceTemplate({
                serviceUri: serviceUri,
                systemName: systemName,
                entityId: entity.getId().toString()
            });
            return _this._currentLanguageProvider.getCurrentLanguage().first().flatMap(function (language) {
                queryParams = [];
                queryParams.push(new idm_de_core_frontend_1.SearchParam('languageId', language.getId()));
                return _this._dataService.load(url, queryParams);
            }).flatMap(function (actions) {
                return _this._meSerializationService.extractActionDtos(actions);
            });
        });
    };
    HttpMEService.prototype.doWorkflowAction = function (systemName, entity, actionId, indicatorEntityAdditionalDataModel) {
        var _this = this;
        return Observable_1.Observable.from(this._applicationPropertiesService.getProperty(this.ME_SERVICE_URI_KEY)).flatMap(function (serviceUri) {
            var url = _this.URL_DO_WORKFLOW_ACTION.replaceTemplate({
                serviceUri: serviceUri,
                systemName: systemName,
                entityId: entity.getId().toString(),
                actionId: actionId.toString()
            });
            return _this._meSerializationService.serializeEntity(systemName, entity)
                .flatMap(function (entity) {
                var data = {
                    entity: entity,
                    additionalData: indicatorEntityAdditionalDataModel
                };
                return _this._dataService.update(url, data);
            })
                .flatMap(function (data) {
                return _this._meSerializationService.deserializeMainEntityWithMeta(systemName, data);
            });
        });
    };
    HttpMEService.prototype.doIpptWorkflowAction = function (systemName, entityId, actionId, indicatorEntityAdditionalDataModel, entity) {
        var _this = this;
        return Observable_1.Observable.from(this._applicationPropertiesService.getProperty(this.ME_SERVICE_URI_KEY)).flatMap(function (serviceUri) {
            var url = _this.URL_DO_WORKFLOW_ACTION.replaceTemplate({
                serviceUri: serviceUri,
                systemName: systemName,
                entityId: entityId.toString(),
                actionId: actionId.toString()
            });
            var data = {
                entity: entity,
                additionalData: { data: entity.data }
            };
            return _this._dataService.update(url, data);
        });
    };
    HttpMEService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [me_data_service_1.MEDataService,
            me_kb_http_service_1.MEKbHttpService,
            idm_message_language_service_client_js_1.LanguageService,
            idm_classifier_service_client_js_1.ClassifierService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], HttpMEService);
    return HttpMEService;
}());
exports.HttpMEService = HttpMEService;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
//# sourceMappingURL=http-me.service.js.map